import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=10da44e5&scoped=true"
import script from "./licenses.vue?vue&type=script&lang=js"
export * from "./licenses.vue?vue&type=script&lang=js"
import style0 from "./licenses.vue?vue&type=style&index=0&id=10da44e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da44e5",
  null
  
)

export default component.exports